<template>
	<div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
		<div>
			<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">
				{{ $t('integrations.whatsapp-profile') }}
			</div>
			<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
				{{ $t('integrations.whatsapp-profile-desc') }}
			</div>
		</div>
		<div class="tw-mt-6 tw-max-w-[750px] tw-text-xl tw-text-gray-950">
			<div class="tw-flex tw-gap-2">
				<span>1.</span>
				<p>
					{{ $t('integrations.visit-the-whatsapp-profile-page-on-your-meta-account') }}
					<a
						class="tw-text-blue-500 tw-underline hover:tw-underline"
						href="https://business.facebook.com/latest/whatsapp_manager/phone_numbers/?business_id=254843552892025&asset_id=357255454146186&nav_ref=whatsapp_manager&tab=phone-numbers&psp_linking_success=0&is_from_mbs=1"
						target="_blank"
					>
						{{ $t('integrations.here') }}
					</a>
				</p>
			</div>

			<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
			<div>
				<div class="tw-mb-1 tw-flex tw-gap-2">
					<span>2.</span>
					<p>
						<span
							>{{
								$t(
									'integrations.after-logging-into-your-account-you-should-find-the-page-below-click-on-the-gear-icon',
								)
							}}
						</span>
					</p>
				</div>
				<img :src="`${imgUrl}/phone-number.png`" class="tw-rounded-sm" />
			</div>

			<div class="tw-my-3 tw-h-[1px] tw-bg-gray-300" />
			<div>
				<div class="tw-mb-1 tw-flex tw-gap-2">
					<span>3.</span>
					<p>
						<span>{{ $t('integrations.step-add-profile-3') }} </span>
					</p>
				</div>
				<Badge
					class="tw-mb-2"
					variant="warning"
					size="sm"
					startIcon="assets/v2/image/icons/alert-circle.svg"
				>
					<span class="tw-text-sm">{{
						$t(
							'integrations.make-sure-your-display-name-is-approved-by-meta-or-some-account-features-will-be-limited',
						)
					}}</span>
				</Badge>
				<img :src="`${imgUrl}/profile-photo.webp`" class="tw-rounded-sm" />
			</div>
		</div>

		<div class="tw-mt-7 tw-flex tw-flex-1 tw-justify-between">
			<div class="tw-flex tw-gap-2">
				<AppButton
					:label="$t('integrations.skip-step')"
					size="xl"
					class="tw-rounded-full"
					type="button"
					@click="skipStep"
					:disabled="skipStepLoading"
					:loading="skipStepLoading"
					secondary
					variant="gray"
				/>

				<a
					href="https://business.facebook.com/latest/whatsapp_manager/phone_numbers/?business_id=254843552892025&asset_id=357255454146186&nav_ref=whatsapp_manager&tab=phone-numbers&psp_linking_success=0&is_from_mbs=1"
					target="_blank"
				>
					<AppButton
						:label="$t('integrations.setup-whatsapp-profile')"
						size="xl"
						class="tw-rounded-full"
						variant="brand"
						customClasses="tw-gap-3"
						endIcon="assets/v2/image/icons/arrow-up-right.svg"
					/>
				</a>
			</div>

			<a v-if="configs.brand == 'Linker'" :href="needHelpUrl" target="_blank">
				<AppButton
					:label="$t('integrations.need-help')"
					variant="secondary"
					endIcon="assets/v2/image/icons/help-circle.svg"
					class="tw-rounded-full"
					size="xl"
				/>
			</a>
		</div>
	</div>
</template>

<script setup>
import Badge from '@/v2/components/badge.vue';

import { ref } from 'vue';
import { WhatsAppMarketplace } from '@/v2/modules/integrations/entities/marketplaces/whatsapp.js';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { Marketplace } from '@/v2/modules/integrations/entities/marketplace';
import { useRouter } from 'vue-router';
import { configs } from '@/v2/system-configs';

const linkMarketplaceStore = useLinkMarketplaceStore();

const needHelpUrl =
	'https://www.linker.com.sa/help-center-articles-ar/setting-up-your-whatsapp-profile-in-business-manager';
const loading = ref(false);
const imgUrl = 'assets/v2/image/whatsapp/profile';
const skipStepLoading = ref(false);
const router = useRouter();

const skipStep = async () => {
	skipStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
		if (linkMarketplaceStore.steps.length < 7) {
            router.push('/v2/integrations/marketplaces');
		}
	} finally {
		skipStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
